// ABOUTME: Builds the quick-add menu actions from the authenticated navigation response.
// ABOUTME: Keeps the AppBar usable while the navigation response is loading.
import React from "react";

import useQueryNavigation from "customHooks/useQuery/useQueryNavigation";
import { useAuthState } from "_ReactContext/AuthContext";

export const getShortcutAddOptions = (navigation: any) => {
    const shortcutAddOptions: any[] = [];
    const features = Array.isArray(navigation?.features)
        ? navigation.features
        : [];
    features.forEach((item: any) => {
        (item.items || []).forEach((menu: any) => {
            if (menu?.addToShorcutAddButton === true) {
                shortcutAddOptions.push(menu);
            }
        });
    });

    shortcutAddOptions.sort((a: any, b: any) => a.order - b.order);
    return shortcutAddOptions;
};

const useGetShortcutAddItems = () => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const { company, user } = useAuthState();
    const queryNavigation = useQueryNavigation(user || "", company.companyId);
    const shortcutAddOptions = getShortcutAddOptions(queryNavigation.data);

    // if (company.companyId.toString() === "10102") {
    //     shortcutAddOptions.push({
    //         uniqueName: "cadastrar_candidato_beta",
    //         route: "/applicant/new/upload?beta=1",
    //         icon: "post_add",
    //         addToShorcutAddButton: true,
    //         isMenuItem: true,
    //         requiresAuthentication: true,
    //         order: 3,
    //         group: "applicantsGroup"
    //     });
    // }
    // const shortcutAddOptions = settingsMenuOptions?.items || [];
    return { anchorEl, setAnchorEl, openMenu, shortcutAddOptions };
};

export default useGetShortcutAddItems;

// ,
//                     "addToShorcutAddButton": true
